import React from 'react';
import { Switch, useHistory } from 'react-router';
import { BaseRoute } from 'src/routing/BaseRoute';
import { IRoute } from '../../../routing/AppRoutes';

import { UserPageTitle } from 'src/features/user/common/UserPageTitle';
import { UserPageCard } from 'src/features/user/common/UserPageCard';

import { isEditingNewsForm } from 'src/utils/helpers';

type PNewContacts = {
  routes: Array<IRoute>;
};

export const CreateNewsLayout: React.FC<PNewContacts> = (props) => {
  const { routes } = props;
  const history = useHistory();

  const isEditForm = isEditingNewsForm(history.location.pathname);
  const dynamicTitle = isEditForm ? 'Edit' : 'New';

  return (
    <UserPageCard>
      <UserPageTitle title={`${dynamicTitle} News`} />
      <Switch>
        {routes.map((route) => (
          <BaseRoute {...route} key={route.path} />
        ))}
      </Switch>
    </UserPageCard>
  );
};
